import { render } from "./App.vue?vue&type=template&id=708f5fbf"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=708f5fbf&lang=css"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__